import React, {  useRef } from "react"
import {
  Map,
  Marker,
  TileLayer,
  ZoomControl,
} from "react-leaflet"
import L from "leaflet"

import CdsamMapSearch from "./CdsamMapSearch"
import classes from "./index.module.scss"

delete L.Icon.Default.prototype._getIconUrl

const customIcon =
  new L.Icon({
    iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  })

const CdsamMap = props => {
  const {
    form,
    setForm,
    formErrors
  } = props

  const mapRef = useRef(null)

  const handleClickMap = async (e) => {
    setForm((prev) => ({
      ...prev,
      coordinates: [e.latlng.lng, e.latlng.lat],
    }))
  }

  return (
    <div className={classes["container"]}>
      <Map
        minZoom={4}
        ref={mapRef}
        zoom={12}
        onClick={handleClickMap}
        className={classes["map"]}
        attributionControl={false}
        zoomControl={false}
        center={{
          lat: form.coordinates[1],
          lng: form.coordinates[0]
        }}
      >
        <ZoomControl position="bottomright" />
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
        />
        {
          !!form.coordinates[0] &&
          <Marker
            icon={customIcon}
            position={{
              lat: form.coordinates[1],
              lng: form.coordinates[0]
            }}
          />
        }
      </Map>

      {
        !!formErrors.coordinates &&
        <div className={classes["error"]}>
          {formErrors.coordinates}
        </div>
      }
      <CdsamMapSearch
        mapRef={mapRef}
        form={form}
        setForm={setForm}
      />
    </div>
  )
}

export default CdsamMap 